import React from 'react';

import values     from '../../../../values';
import Context    from '../../../../context';
import Components from './Components';

import { useTranslation                                                    } from 'react-i18next';
import { BreadCrumb, TableHeader, TableLoading, Pagination, ResponsiveView } from '../../../../components';

import './index.sass';

type Props = {
  rqData: any;
}

const Paymentonline2CompanyScreen: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { t } = useTranslation();
  const { setFactorRequest, factorRequest } = React.useContext(Context.PaymentOnline2CompanyContext);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <ResponsiveView.Container id='payment-online-2-company-screen'>
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </ResponsiveView.Column>
        <ResponsiveView.Column extraLarge={9} large={7} medium={7} className="search-and-filter-wrapper">
          <Components.Filter />
          <Components.Payment />
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <div className="table-content-wrapper">
        <table>
          <TableHeader headers={values.tableHeaders.PAYMENT_ONLINE_4_COMPANY.map((item) => t(item))}/>
          {props.rqData?.status === "loading" ? (<TableLoading />) : (<Components.Body data={props.rqData} />)}
        </table>
      </div>
      <div
        style={{display: "flex", justifyContent: "center", marginTop: "2rem", gap: "1rem",}}>
        <div></div>
      </div>
      {props.rqData?.status === "success" &&
        props.rqData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={Number(factorRequest!.page)}
              totalPages={props.rqData?.data?.result?.totalPages}
              onPaginate={(page: number) => setFactorRequest!({...factorRequest, page: page,})}
            />
          </div>
        )}
    </ResponsiveView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

}

export default Paymentonline2CompanyScreen;
